import { Capabilities } from './Capabilities';

// The set of capabilities that together constitute "AI Access" on a workbook/view: Full Data Query
// (`connect`) + AI Access (`ai_access`). This is the SINGLE SOURCE OF TRUTH for the aiAccess "Grant
// AI Access" flow, so editing it changes grant BEHAVIOR. Two consumers derive from it:
//   1. the grant template — the capabilities actually granted (GrantPermissionsAfterSharingDialog);
//   2. the gap-check — which recipients are missing AI access and thus pulled into the grant flow
//      (GrantAccessPermissionsHelper.getUsersWithoutAiAccessPermissionsForContent).
// Values are capability `.name` strings — what effective-permission wire tokens are keyed by.
// `Capabilities.connect` also matches `CapabilityInfo.connectWorkbook` ("Full Data Query") since
// both share that name.
export const AI_ACCESS_CAPABILITY_SCOPE: ReadonlyArray<string> = [
  Capabilities.connect, // 'connect'   -> "Full Data Query" (connectWorkbook)
  Capabilities.aiAccess, // 'ai_access' -> "AI Access"
];
